import styled from "styled-components";
import { OutlinedInput as MuiOutlinedInput, InputLabel as MuiInputLabel } from "@mui/material";

// Base interface for common input styling props
export interface BaseInputStyleProps {
  has_error?: string;
  theme: any;
}

// Common base styles shared across all input components
export const getBaseInputStyles = (theme: any, has_error?: string) => ({
  borderRadius: "8px",
  backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
  height: "56px",
  minHeight: "56px",

  "& .MuiOutlinedInput-input": {
    caretColor: theme.colors_ds.PRIMARY_ICON_MAIN,
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "20px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: has_error
      ? theme.colors_ds.DANGER_GRAPH_DEFICIT
      : theme.colors_ds.NEUTRAL_BORDER_WEAK,
    top: 0,
  },

  "& legend": {
    display: "none",
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: has_error
      ? theme.colors_ds.DANGER_GRAPH_DEFICIT
      : theme.colors_ds.NEUTRAL_BORDER_DEFAULT,
  },

  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: has_error
      ? theme.colors_ds.DANGER_GRAPH_DEFICIT
      : theme.colors_ds.PRIMARY_ICON_MAIN,
    borderWidth: "1px",
  },

  fieldset: {
    top: 0,
  },
});

// Base styled input component that can be extended
export const BaseStyledOutlinedInput = styled(MuiOutlinedInput)<BaseInputStyleProps>(
  ({ theme, has_error }) => ({
    ...getBaseInputStyles(theme, has_error),

    "& .MuiOutlinedInput-input": {
      ...getBaseInputStyles(theme, has_error)["& .MuiOutlinedInput-input"],
      padding: "24px 12px 10px 12px", // Default padding with label
      width: "100%",
    },
  })
);

// Shared input label styles
export const BaseStyledInputLabel = styled(MuiInputLabel)(({ theme }) => ({
  fontFamily: "var(--font-Medium)",
  fontSize: "10px",
  backgroundColor: "transparent",
  transition: "transform 0.2s ease-in-out",
  color: theme.colors_ds.NEUTRAL_TEXT_WEAK,

  "&.Mui-focused": {
    color: theme.colors_ds.PRIMARY_ICON_MAIN,
  },
}));

// Common input padding values
export const INPUT_PADDING = {
  withLabel: "24px 12px 10px 12px",
  withoutLabel: "16px 12px",
  labelTop: "52px 12px 16px 12px", // For full height multiline
  labelTopMultiline: "38px 12px 19px 12px", // For regular multiline
};

// Common label transform values
export const LABEL_TRANSFORM = {
  shrunk: "translate(12px, 6px) scale(1)",
  normal: "translate(12px, 16px) scale(1.5)",
};
